module.exports = __webpack_public_path__ + "fonts/Lato-Light.2fe27d9d.ttf";